// Format helper utilities

export const uppercaseFirstLetter = (str) => {
  return typeof str === 'string' ? str.charAt(0).toUpperCase() + str.slice(1) : '';
};

export const formatCount = (count) => {
  if (count >= 1000000) {
    return (count / 1000000).toFixed(1) + 'M';
  } else if (count >= 1000) {
    return (count / 1000).toFixed(1) + 'K';
  }
  return count.toString();
};

export const formatTimeAgo = (date) => {
  const now = new Date();
  const diff = now.getTime() - new Date(date).getTime();
  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
  const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));

  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes}m`;
  if (hours < 24) return `${hours}h`;
  if (days < 60) return `${days}d`;
  if (months < 12) return `${months}mon`;
  return `${years}y`;
};

/**
 * Replaces localhost in image URLs with the current hostname (IP address)
 * This allows images to load correctly when accessing from mobile devices
 * @param {string} url - The image URL
 * @returns {string} - URL with localhost replaced by current hostname
 */
export const replaceLocalhostInUrl = (url) => {
  if (!url) return url;
  
  // Only replace if we're not on localhost and the URL contains localhost
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      // Replace localhost with current hostname
      return url.replace(/localhost/g, hostname).replace(/127\.0\.0\.1/g, hostname);
    }
  }
  
  return url;
};

